<template>
  <div class="saved-lists">
    <div class="saved-lists__filter-wrapper row">
      <mi-refresh-btn
        class="saved-lists__refresh-btn"
        @clicked-refresh-btn="onHandleFilterChange()"
      ></mi-refresh-btn>
      <div class="saved-lists__divider"></div>
      <mi-btn
        :class="filters.mineOnly && 'saved-lists__filter-btn--selected'"
        flat
        :color="mineOnlyBtnColor"
        @click="onHandleFilterChange({ filterKey: 'mineOnly', isBooleanType: true })"
      >
        Mine only
      </mi-btn>
      <div class="saved-lists__divider"></div>
      <mi-btn
        :class="filters.todaysFilter && 'saved-lists__filter-btn--selected'"
        flat
        :color="todayBtnColor"
        @click="onHandleFilterChange({ filterKey: 'todaysFilter', isBooleanType: true })"
      >
        From today
      </mi-btn>
      <div class="saved-lists__divider"></div>
      <div class="q-ml-lg col-lg-4 col-sm-6">
        <mi-text-field
          :model-value="filters.searchField"
          bg-color="white"
          debounce="300"
          placeholder="Search"
          clearable
          hide-bottom-space
          outlined
          @update:model-value="(value) => onHandleFilterChange({ filterKey: 'searchField', value })"
        >
          <template #prepend>
            <mi-icon name="search"></mi-icon>
          </template>
        </mi-text-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import MiBtn from '@/packages/@mi-library/MiBtn/MiBtn.vue'

  export default {
    name: 'SavedListsFilterBar',
    components: { MiBtn },
    props: {
      filters: {
        type: Object,
        required: true
      }
    },
    emits: ['on-handle-filters'],
    setup(props, { emit }) {
      const mineOnlyBtnColor = computed(() => (props.filters.mineOnly ? 'white' : 'primary'))
      const todayBtnColor = computed(() => (props.filters.todaysFilter ? 'white' : 'primary'))

      const onHandleFilterChange = ({ filterKey = '', value = '', isBooleanType = false } = {}) => {
        const filterValue = isBooleanType ? !props.filters[filterKey] : value || ''
        emit('on-handle-filters', filterKey, filterValue)
      }

      return {
        mineOnlyBtnColor,
        todayBtnColor,
        onHandleFilterChange
      }
    }
  }
</script>

<style lang="scss" scoped>
  .saved-lists {
    max-width: 100vw;

    &__filter-wrapper {
      height: 3.75rem;
      width: 100%;
      justify-content: flex-start;
      align-items: center;
      padding: .5rem 1rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, .24);
      position: relative;
    }

    &__refresh-btn {
      width: 48px;
      height: 48px;
      padding-right: 1rem;
    }

    &__divider {
      border: 1px solid $mi-anthracite-50;
      height: 27px;
    }

    &__filter-btn {
      &--selected {
        background-color: $mi-anthracite-800;
      }
    }

    &__content {
      padding: 24px;
    }
  }
</style>
